import ApiService from '@/services/core/api.service'

const DashboardService = {
  async get () {
    return ApiService.get('rad/dashboard/statistics')
  }
}

export default DashboardService
